module.exports = __webpack_public_path__ + "static/media/Nav_Dashboard.39d6305e.svg";